import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Card, Typography } from 'antd'
import PropTypes from 'prop-types'
import { SearchOutlined } from '@ant-design/icons'
import { isEmpty } from 'lodash'
import Breadcrumb from 'components/Breadcrumb'
import { useLocation } from 'react-router-dom'

import './SearchHeader.scss'
import useWindowSize from 'components/logic/useWindowSize'

const clientType = localStorage.getItem('clientType')

const { Title } = Typography
const getNameView = location => {
  let name
  if (location.includes('/accounts')) name = 'Usuários'
  if (location.includes('/organizations')) name = 'Organizações'
  if (location.includes('/clients')) name = 'Clientes'
  if (location.includes('/clinics') || location.includes('/clinics/new'))
    name = 'Clínicas'
  if (location.includes('/patients')) name = 'Pacientes'
  if (location.includes('/exams')) name = 'Serviços'
  if (location.includes('/listing-reports')) name = 'Lista de exames'
  if (location.includes('/pending-reports'))
    name = clientType === 'TELEMEDICINE_CENTER' ? 'Laudos' : 'Laudos Pendentes'
  if (location.includes('/historics')) name = 'Histórico'
  if (location.includes('/device-calibration')) name = 'Controle de Qualidade'
  return name
}

function Input({ id, placeholder, value, suffix, onChange, openSearchBox }) {
  const { width } = useWindowSize()
  const ref = useRef(null)

  return (
    <div className="search-input_wrapper" ref={ref}>
      <input
        className="search-input"
        id={id}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
      <button
        className="suffix-box"
        style={{ zIndex: 10 }}
        onClick={() => (width <= 700 ? openSearchBox(ref) : {})}>
        {suffix}
      </button>
    </div>
  )
}

export default function SearchHeader({
  title,
  onChangeSearchQuery,
  extras,
  hiddenSearch,
  placeholder = 'Pesquisar...'
}) {
  const [searchQuery, setSearchQuery] = useState(null)
  const query = localStorage.getItem('query')
  const location = useLocation()

  const mobileInputRef = useRef(null)

  const [searchActive, isSearchActive] = useState(false)
  const openSearchBox = useCallback(
    buttonRef => {
      if (!!mobileInputRef && !!buttonRef) {
        const input = mobileInputRef.current
        const button = buttonRef.current

        if (!searchActive) {
          isSearchActive(true)

          input.style.width = '100%'
          input.style.paddingLeft = '80px'

          if (!isEmpty(extras)) button.style.right = '-170px'

          input.focus()
        } else {
          input.style.width = 0
          input.style.paddingLeft = 0
          button.style.right = 0
          input.blur()

          isSearchActive(false)
        }
      }
    },
    [searchActive, extras]
  )

  useEffect(() => {
    let timer = null
    if (query) {
      setSearchQuery(query)

      localStorage.removeItem('query') // Reseta pesquisa
    }

    if (searchQuery !== null)
      timer = setTimeout(() => {
        onChangeSearchQuery(searchQuery)
      }, 500)
    return () => {
      if (timer) clearTimeout(timer)
    }
  }, [searchQuery]) // eslint-disable-line
  return (
    <Card className="search-header">
      <div className="content">
        <div>
          <div>
            <Title level={3} style={{ color: 'white' }}>
              {getNameView(location?.pathname) || title}
            </Title>
          </div>
          <div style={{ marginTop: '-10px' }}>
            <Breadcrumb />
          </div>
        </div>
        {hiddenSearch !== true && (
          <div
            className="wrap"
            style={isEmpty(extras) ? { justifyContent: 'flex-end' } : {}}>
            <Input
              id="search-input"
              placeholder={placeholder}
              value={searchQuery}
              suffix={<SearchOutlined />}
              onChange={event => setSearchQuery(event.target.value)}
              openSearchBox={openSearchBox}
            />
            {!isEmpty(extras) && extras.map(extra => extra)}
          </div>
        )}
      </div>

      <div className="content">
        <input
          className="mobile-search_input"
          placeholder="Pesquisar..."
          value={searchQuery}
          style={!searchActive ? { visibility: 'hidden' } : {}}
          onChange={event => setSearchQuery(event.target.value)}
          ref={mobileInputRef}
        />
      </div>
    </Card>
  )
}

SearchHeader.propTypes = {
  title: PropTypes.string,
  onChangeSearchQuery: PropTypes.func,
  extras: PropTypes.array
}
